import { createSlice, current } from '@reduxjs/toolkit';
import {
	getMeasurementFrequencyList,
	getMeasurementFrequency,
	addNewMeasurementFrequency,
	updateMeasurementFrequency,
	deleteMeasurementFrequency,
	checkMeasurementFrequencyExists,
} from './thunk';

export const initialState = {
	itemMeasurementFrequencyList: [],
	itemMeasurementFrequency: null,
	isMeasurementFrequencyLoading: false,
	isMeasurementFrequencySuccess: false,
	dataMeasurementFrequency: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const MeasurementFrequencySlice = createSlice({
	name: 'MeasurementFrequency',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getMeasurementFrequencyList.pending, state => {
			state.isLoadingList = true;
			state.isMeasurementFrequencySuccess = false;
		});

		builder.addCase(getMeasurementFrequencyList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemMeasurementFrequencyList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isMeasurementFrequencySuccess = true;
		});

		builder.addCase(getMeasurementFrequencyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isMeasurementFrequencySuccess = false;
		});

		builder.addCase(getMeasurementFrequency.pending, state => {
			state.isMeasurementFrequencyLoading = true;
			state.isMeasurementFrequencySuccess = false;
		});

		builder.addCase(getMeasurementFrequency.fulfilled, (state, action) => {
			state.itemMeasurementFrequency = action.payload;
			state.isMeasurementFrequencyLoading = false;
			state.isMeasurementFrequencySuccess = true;
		});

		builder.addCase(getMeasurementFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isMeasurementFrequencyLoading = false;
			state.isMeasurementFrequencySuccess = false;
		});

		builder.addCase(addNewMeasurementFrequency.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewMeasurementFrequency.fulfilled, (state, action) => {
			state.itemMeasurementFrequencyList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewMeasurementFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateMeasurementFrequency.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateMeasurementFrequency.fulfilled, (state, action) => {
			state.itemMeasurementFrequencyList = state.itemMeasurementFrequencyList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateMeasurementFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteMeasurementFrequency.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteMeasurementFrequency.fulfilled, (state, action) => {
			state.itemMeasurementFrequencyList = current(
				state.itemMeasurementFrequencyList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteMeasurementFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkMeasurementFrequencyExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkMeasurementFrequencyExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkMeasurementFrequencyExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = MeasurementFrequencySlice.actions;

export default MeasurementFrequencySlice.reducer;
